import { WplywContext } from "../../../../context/wplywContext";
import { useContext } from "react";
import datetimeParser from "../../../../components/datetimeParser";
import getWeekOfYearFromTimestamp from "../../../../components/getWeekOfYear";
import ConfirmStatus from "./Confirm/ConfirmStatus";
const HeaderInfo = () => {
	const { wplyw } = useContext(WplywContext);
	const hasPendingPrzekazXml =
		Number(
			wplyw?.wplyw_data?.data?.msr_wplywy
				?.msr_wplywy_has_pending_przekaz_xml || 0,
		) === 1;

	return (
		<div
			style={{
				display: "flex",
				gap: "20px",
				alignItems: "center",
				flexWrap: "wrap",
			}}
		>
			{hasPendingPrzekazXml ? (
				<div
					style={{
						padding: "10px 20px",
						background: "#cf1322",
						color: "white",
					}}
				>
					Są niewygenerowane XML z przelewów do przekazania
				</div>
			) : (
				<></>
			)}
			{ConfirmStatus() ? (
				<div
					style={{
						padding: "10px 20px",
						background: "#52C41A",
						color: "white",
					}}
				>
					ETAP ZATWIERDZONY
				</div>
			) : (
				<></>
			)}
			{wplyw.mode == "preview" ? (
				<div
					style={{
						padding: "10px 20px",
						background: "red",
						color: "white",
					}}
				>
					PODGLĄD
				</div>
			) : (
				""
			)}
			<div style={{ fontSize: "16px" }}>
				ID wpływu: #
				{wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_own_id}
			</div>
			<div style={{ fontSize: "16px" }}>
				Data wpływu:{" "}
				{datetimeParser(
					wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_date_in,
					"YYYY-MM-DD",
				)}{" "}
				|{" "}
				{getWeekOfYearFromTimestamp(
					wplyw?.wplyw_data?.data?.msr_wplywy?.msr_wplywy_date_in,
				)}{" "}
				tydzień
			</div>
			<div style={{ fontSize: "16px" }}>
				Utworzone przez:{" "}
				{
					wplyw?.wplyw_data?.data?.msr_wplywy?.userDetails
						?.mlg_users_fullname
				}
			</div>
		</div>
	);
};

export default HeaderInfo;
